import React, { useContext, useEffect, useState } from "react";
import "./Cart.css";
import Breadcrumb_Comp from "../common/common_components/breadcrumb_comp/Breadcrumb_Comp";
import Cart_Product_Card from "./cart_product_card/Cart_Product_Card";
import Payment_Summary from "../profile/right_side_content/inner_details_pages/order_details/payment_summary/Payment_Summary";
import Sankalp_Notes_Modal from "../common/modals/sankalp_notes_modal/Sankalp_Notes_Modal";
import { Context } from "../../utils/context";
import { useDispatch, useSelector } from "react-redux";
import { getAllCart } from "../../features/cart/cartSlice";
import Orange_Btn from "../common/common_btn/orange_btn/Orange_Btn";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";

const Cart = ({ deliveryNote, setDeliveryNote }) => {
  const breadcrumbs = [
    { label: "SHOP", link: "/explore-latest-products", active: false },
    { label: "CART", link: "", active: true },
  ];

  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { signin } = useContext(Context);

  const allCart = useSelector((state) => state.cart.allCarts);

  useEffect(() => {
    dispatch(getAllCart(signin));
  }, [dispatch, signin]);

  const saveTotal = (cart) => {
    let totalMRP = 0;
    let totalSelling = 0;
    let totalTax = 0;
    let totalCess = 0;
    let itemCount = 0;
    if (cart?.data?.data?.length > 0) {
      for (const item of cart.data.data) {
        const qty = Number(item.quantity);
        const price = Number(item?.Product?.price || 0);
        const mrp = Number(item?.Product?.mrp || 0);
        const taxPerc = Number(item?.Product?.tax_percentage || 0);
        const cessPerc = Number(item?.Product?.cess_percentage || 0);

        totalSelling += price * qty;
        totalMRP += mrp * qty;

        // totalTax += (price * qty * taxPerc) / 100;
        // totalCess += (price * qty * cessPerc) / 100;

        itemCount += 1;
      }
    }

    const grandTotal = totalSelling + totalTax + totalCess;
    const totalSavings = totalMRP - totalSelling;

    return {
      total_mrp: totalMRP.toFixed(2),
      total_selling_price: totalSelling.toFixed(2),
      total_tax: totalTax.toFixed(2),
      total_cess: totalCess.toFixed(2),
      no_of_item: itemCount,
      total_savings: totalSavings.toFixed(2),
      grand_total: grandTotal.toFixed(2),
    };
  };

  const [data, setData] = useState();

  useEffect(() => {
    const data = saveTotal(allCart);
    setData(data);
  }, [allCart]);


  return (
    <section className="Cart">
      <div className="container">
        <Breadcrumb_Comp data={breadcrumbs} />
        {allCart?.data?.data?.length > 0 ? (
          <div className="row">
            <div className="col-lg-8">
              <div className="left_side_container">
                <div className="product_card_holder">
                  {allCart.data.data.map((item) => (
                    <Cart_Product_Card key={item.id} cartItem={item} />
                  ))}
                </div>
                {allCart?.data?.data?.length !== 0 && (
                  <>
                    {deliveryNote ? (
                      <div className="container">
                        <p className="text">Delivery Note</p>
                        <p className="text">{deliveryNote}</p>
                      </div>
                    ) : (
                      <div
                        className="delivery_note_div"
                        onClick={() => setShowModal(true)}
                      >
                        <p className="text">Delivery Note (Optional)</p>
                        <p className="plus_text">+</p>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>

            <div className="col-lg-4">
              <div className="right_side">
                <Payment_Summary allCart={allCart} data={data} />
              </div>
            </div>
          </div>
        ) : (
          <div style={{ textAlign: "center", padding: "40px" }}>
            <p style={{ fontSize: "20px", margin: "10px 0 0" }}>
              Your cart is empty
            </p>

            <Button
              style={{
                marginTop: "20px",
                padding: "10px 25px",
                fontSize: "16px",
                background: "#E47102",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
              }}
              onClick={() => navigate("/all-products")}
            >
              Shop Now
            </Button>
          </div>
        )}
      </div>

      <Sankalp_Notes_Modal
        setDeliveryNote={setDeliveryNote}
        modalTitle="Delivery Note"
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      />
    </section>
  );
};

export default Cart;
